module.exports = __webpack_public_path__ + "static/fonts/ionicons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.woff?v=3.0.0
// module id = 459
// module chunks = 103